import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import AppCard from '../../../../../components/ui/AppCard';
import legalBGImage from '../../../../../assets/images/patterns/applylegalPolicy.png';
import CashPlanBGImage from '../../../../../assets/images/patterns/applycashplanPolicy.png';
import LoanBGImage from '../../../../../assets/images/patterns/loans-bg-2.png';
import paymentImage from '../../../../../assets/images/patterns/payments-bg.png';

export default function NewApplicationPolicyDisplay() {
  const history = useHistory();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-8">
      <AppCard headerImg={legalBGImage}>
        <div className="flex flex-col text-center md:text-left h-full justify-between">
          <div>
            <h3 className="text-xl font-bold text-base-content mb-2">Apply for Legal Aid and Cash Plan Policy now!</h3>
            <p className="text-sm text-base-content/70 mb-4">
              <strong className="block mb-1 text-base-content">Get yourself cover</strong>
              Create your legal aid or cash plan policy today and embrace a peace of mind.
            </p>
          </div>
          <div className="mt-4">
            <Button
              className="w-full md:w-auto"
              size="large"
              label={<strong>Apply Now</strong>}
              severity="info"
              rounded
              outlined
              raised
              onClick={() => {
                history.push("/apply-policy?category=Legal aid");
              }}
            />
          </div>
        </div>
      </AppCard>

      <AppCard headerImg={CashPlanBGImage}>
        <div className="flex flex-col text-center md:text-left h-full justify-between">
          <div>
            <h3 className="text-xl font-bold text-base-content mb-2">Apply for Cash Plan Policy now!</h3>
            <p className="text-sm text-base-content/70 mb-4">
              <strong className="block mb-1 text-base-content">Get cash assistance</strong>
              Apply for your cash plan policy today and embrace a peace of mind.
            </p>
          </div>
          <div className="mt-4">
            <Button
              className="w-full md:w-auto"
              size="large"
              label={<strong>Apply Now</strong>}
              severity="info"
              rounded
              outlined
              raised
              onClick={() => {
                history.push("/apply-policy?category=Cash plan");
              }}
            />
          </div>
        </div>
      </AppCard>

      <AppCard headerImg={LoanBGImage}>
        <div className="flex flex-col text-center md:text-left h-full justify-between">
          <div>
            <h3 className="text-xl font-bold text-base-content mb-2">Get a loan now!</h3>
            <p className="text-sm text-base-content/70 mb-4">
              <strong className="block mb-1 text-base-content">
                We offer the following services: short term loans
              </strong>
              foreign exchange services; investments; financial intelligence; financial planning.
            </p>
          </div>
          <div className="mt-4">
            <Button
              className="w-full md:w-auto"
              size="large"
              label={<strong>Apply Now</strong>}
              severity="info"
              rounded
              outlined
              raised
              onClick={() => {
                history.push("/loans");
              }}
            />
          </div>
        </div>
      </AppCard>

      <AppCard headerImg={paymentImage}>
        <div className="flex flex-col text-center md:text-left h-full justify-between">
          <div>
            <h3 className="text-xl font-bold text-base-content mb-2">Make Payments</h3>
            <p className="text-sm text-base-content/70 mb-4">
              Make payments to your policy and stay update. All Payments in USD.
            </p>
          </div>
          <div className="mt-4">
            <Button
              className="w-full md:w-auto"
              size="large"
              label={<strong>Make Payments</strong>}
              severity="info"
              rounded
              outlined
              raised
              onClick={() => {
                history.push("/payments");
              }}
            />
          </div>
        </div>
      </AppCard>
    </div>
  );
}
